// This is a default color mapping helper for CSS variables.
// Feel free to override or define your own based on your design system.
export default {
  primary: "var(--color-primary)",
  "primary-foreground": "var(--color-primary-foreground)",
  secondary: "var(--color-secondary)",
  "secondary-foreground": "var(--color-secondary-foreground)",
  background: "var(--color-background)",
  foreground: "var(--color-foreground)",
  muted: "var(--color-muted)",
  "muted-foreground": "var(--color-muted-foreground)",
  accent: "var(--color-accent)",
  "accent-foreground": "var(--color-accent-foreground)",
  destructive: "var(--color-destructive)",
  "destructive-foreground": "var(--color-destructive-foreground)",
  border: "var(--color-border)",
  input: "var(--color-input)",
  ring: "var(--color-ring)",
};
